module.exports = __webpack_public_path__ + "src/assets/games/1/250.jpg";